<template>
  <div class="form-group esma_form_group">
    <label v-if="showLabel" :for="fieldID"
    :class="labelClass">{{fieldLabel}} <span v-if="isRequired" class="is_required" aria-hidden="true">＊</span></label>
    <div :class="fieldClass"  style="padding:1px 0px 1px 7px;">
      <div class="row"> </div>
      <div class="col-xs-5"  style="margin: 0px;padding: 0px;">
        <input
          :style="filedStyle"
          :disabled="isDisabled"
          :id="fieldID + '_user'"
          :name="fieldID + '_user'"
          :value="fieldValueUser"
          type="text"
          class="form-control"
          style="text-align:end;"
          @input="updateValueUser($event.target.value)"
          placeholder="">
      </div>
      <div class="col-xs-1"  style="margin: 0px;padding: 0px;text-align: center;">
        <input
          style="text-align: center; color: black; padding: 0px;"
          :disabled="isDisabled"
          :id="fieldID + '_at'"
          :name="fieldID + '_at'"
          value="@"
          :readonly="true"
          type="text"
          class="form-control">
      </div>
      <div class="col-xs-6"  style="margin: 0px;padding: 0px;">
    <input v-if="isDisabled"
      :style="vSelectFiledDisabledStyle"
      :disabled="isDisabled"
      :id="fieldID + '_domain_disabled'"
      :name="fieldID + '_domain_disabled'"
      :value="fieldValue"
      type="text"
      class="form-control"
      style="text-align:end;"
      placeholder="">
    <v-select v-else
        :style="vSelectFiledStyle"
        :noDrop="isDisabled"
        class="style-chooser-email"
        :clearable="false"
        :options="fieldOptions"
        :single-line="true"
        :value="fieldValue"
        @input="updateValueDomainOption"
        :taggable="true"
      >
      <template slot="no-options" >
          Manual input
        </template>
      </v-select>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { bus } from "@/libs/bus";
import debug from "debug";
import _ from "lodash";
import { utils } from "@/libs/utils";
var debug_select = debug("esma:select-box");
import vSelect from "vue-select";
import "../../../node_modules/vue-select/dist/vue-select.css";
export default {
  data() {
    return {
      local_options: [],
      selection_rules: false,
      listen_for: false,
      forced_options: null,
      value_updated:false,
      cache_for_disable_and_clean_if_value:false,
      local_disabled:false,
      label_class:"col-xs-4 control-label esma_form_label",
      value_user:"",
      value_domain:"",
      updated_value_user:false,
      updated_value_domain:false,
      updated_value_user_set:false,
      updated_value_domain_set:false,
      local_refresh_sequecnce: 1,
      show_as_error:false,
      last_disabled_status:null,
      page_controller_disabled:false,
    };
  },
  components: {
    'v-select':vSelect
  },
    computed: {
      pageControllerDisabled:{
        get(){
          return this.page_controller_disabled;
        },
        set(v){
          this.page_controller_disabled = v;
        }
      },
      isRequired(){
          return this.$props.data.error_if_blank || this.$props.data.error_if_blank || false;
      },
      showAsError:{
        get(){
          return this.show_as_error;
        },
        set(v){
          this.show_as_error = v;
        }
      },
      localRefreshSequecnce:{
        get(){
          return this.local_refresh_sequecnce;
        },
        set(v){
          this.local_refresh_sequecnce = v;
        }
      },
      valueUser:{
        get(){
          return this.value_user;
        },
        set(v){
          this.value_user = v;
        }
      },
      valueDomain:{
        get(){
          return this.value_domain;
        },
        set(v){
          this.value_domain = v;
        }
      },
      labelClass(){
        var complement = (this.showAsError == true)? " esma_error_field":"";
        if(typeof this.$props.data.label_class != "undefined"){
          return this.$props.data.label_class + complement
        }else{
          return this.label_class + complement
        }
      },
      localDisabled:{
        get(){
          return this.local_disabled;
        },
        set(v){
          this.local_disabled = v;
        }
      },
      filedStyle() {
        var store_style = this.$store.state[this.stateCurrentRow.replace("current_row","current_field_style")][this.fieldID] || ";color:black;";
        return (this.$props.data.field_style || "") + store_style + "";
      },
      vSelectFiledDisabledStyle(){
        var store_style = this.$store.state[this.stateCurrentRow.replace("current_row","current_field_style")][this.fieldID] || ";color:black;";
        return (this.$props.data.field_style || "") + store_style + ";text-align: start;";
      },
      vSelectFiledStyle() {
          return "";//"font-size: 14px;";
      },
      stateCurrentRow(){
        if(typeof this.$props.data.state_current_row != "undefined"){
          return this.$props.data.state_current_row;
        }else{
          return "current_row";
        }
      },
      stateCurrentEditing(){
        if(typeof this.$props.data.state_current_editing != "undefined"){
          return this.$props.data.state_current_editing;
        }else{
          return "current_editing";
        }
      },
      stateIsEditingNew(){
        if(typeof this.$props.data.state_is_editing_new != "undefined"){
          return this.$props.data.state_is_editing_new;
        }else{
          return "is_editing_new";
        }
      },
      fieldTableName() {
        return this.$props.data.table_name;
      },
      fieldOptions() {
        var base_options = this.$props.data.options;

        this.local_options = [];
        base_options.forEach(d => {
          this.local_options.push(d);
        });
        if (this.local_options.indexOf(this.fieldValue) < 0) {
          this.local_options.unshift(this.fieldValue);
        }
        if(this.local_options.indexOf("") < 0 && this.fieldValue != "" && this.fieldValue != null){
          this.local_options.unshift("");
        }
        return this.local_options;
      },
      fieldLabel() {
        return this.$props.data.label;
      },
      fieldValueUser(){
        this.valueUser = _.clone(this.$store.state[this.stateCurrentRow][this.fieldID]);
        if(this.valueUser && this.valueUser.indexOf("@") >-1){
          this.valueUser = this.valueUser.split("@")[0];
        }
        // else{
        //   this.valueUser = "";
        // }
        return (this.localRefreshSequecnce > 0) ? this.valueUser:"";
      },
      fieldValue() {
        this.valueDomain =_.clone(this.$store.state[this.stateCurrentRow][this.fieldID]);
        if(this.valueDomain && this.valueDomain.indexOf("@") >-1){
          this.valueDomain = this.valueDomain.split("@")[1];
        }else{
          this.valueDomain = ""
        }
        if (typeof this.$props.data.on_set_value == "function") {
          this.$props.data.on_set_value(this.valueDomain)
        }
        return (this.localRefreshSequecnce > 0) ? this.valueDomain:"";
      },
      fieldID() {
        return this.$props.data.id;
      },
      fieldClass() {
        if(typeof this.$props.data.field_class != "undefined"){
          return this.$props.data.field_class;
        }else if (this.getOption("hide_label", false) == true) {
          return "col-xs-12";
        } else {
          return "col-xs-8";
        }
      },
      showLabel() {
        if (this.getOption("hide_label", false) == true) {
          return false;
        } else {
          return true;
        }
      },
      isDisabled() {
        var ret = null;
        if (this.$store.state[this.stateIsEditingNew] == true) {
          ret = this.pageControllerDisabled || this.localDisabled ||this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined"; //TODO, can also has another field to force it.
        } else {
          ret = this.pageControllerDisabled || this.localDisabled ||this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined";
        }
        if(this.last_disabled_status != null && this.last_disabled_status != ret){
          this.localRefreshSequecnce++;
        }
        this.last_disabled_status = ret;
        return ret;
      }
  },
  methods: {
    onClick() {
    },
    updateValueDomainOption(v) {
      if(v && v.length > 0 && v.indexOf("@") != 0){
        v = "@" + v;
      }
      // this.$store.state[this.stateCurrentRow][this.fieldID] = this.valueUser + v;
      this.updateValueDomain(v);
    },
    updateValueDomain(d) {
      this.updated_value_domain =d;
      this.updated_value_domain_set = true;
      var user = "";
      if(this.updated_value_user_set == true){
        user = this.updated_value_user;
      }else{
        user = this.valueUser
      }
      debug_select("updateValueDomain",d)
      this.value_updated = true;
      this.$store.state[this.stateCurrentEditing][this.fieldID] = user + d;
      this.$store.state[this.stateCurrentRow][this.fieldID] = user + d;

      if(this.$props.data.emit_input == true){
        this.$emit("on_update",{field:this.fieldID,val:this.$store.state[this.stateCurrentEditing][this.fieldID]});
      }
      this.localRefreshSequecnce++;
    },
    updateValueUser(d){
      var domain  = ""
      if(this.updated_value_domain_set){
        domain = this.updated_value_domain
      }else{
        domain = this.valueDomain
      }
      if((d||"").indexOf("@") > -1){
        d= d.replace(/@/g,"");
      }
      this.updated_value_user =d;
      this.updated_value_user_set =true;
      this.$store.state[this.stateCurrentEditing][this.fieldID] =d +  domain;
      if(this.$props.data.emit_input == true){
        this.$emit("on_update",{field:this.fieldID,val:this.$store.state[this.stateCurrentEditing][this.fieldID]});
      }
    },
    updateValue(d){
      this.$store.state[this.stateCurrentEditing][this.fieldID] =d;
      if(this.$props.data.emit_input == true){
        this.$emit("on_update",{field:this.fieldID,val:this.$store.state[this.stateCurrentEditing][this.fieldID]});
      }
    },
    getOption(name, def) {
      if (typeof this.$props.option[name] == "undefined") {
        return def;
      }
      return this.$props.option[name];
    },
    onReceiveEvents(e, data) {
    },
    refreshOptions(){
      var temp = _.clone(this.local_options)
      this.local_options = [];
      temp.forEach(e=>{
        this.local_options.push(e)
      })
    }
  },
  mounted() {
    this.$props.data.ref_field = this;
    this.valueUser = "";
    this.valueDomain = "";

    if (typeof this.$props.data.selection_rules != "undefined" && this.$props.data.selection_rules.length > 0) {
      this.selection_rules = this.$props.data.selection_rules;
    }
    if (typeof this.$props.data.listen_for != "undefined" && this.$props.data.listen_for.length > 0) {
      this.listen_for = this.$props.data.listen_for;
      this.listen_for.forEach(e => {
        bus.$off(e.name).$on(e.name, data => {
          this.onReceiveEvents(e, data);
        });
      });
    }


    this.$props.data.on_field_messages = (vm,msg,cb) =>{
      if(msg && msg.msg_type == "error"){
        if(msg.show_as_error_mode == false && this.showAsError == false){
          this.localRefreshSequecnce++;
          return cb(false);
        }
        var local_val = _.clone(this.$store.state[this.stateCurrentEditing][this.fieldID]);
        if(typeof local_val == "undefined"){
          local_val = _.clone(this.$store.state[this.stateCurrentRow][this.fieldID]);
        }
        this.showAsError = msg.show_as_error_mode || false;
        if(utils.if_null(local_val) == ""){ //  BOTH IS EMPTY
        }else if(local_val.indexOf("@") < 0 || utils.if_null(local_val.split("@")[1]) == ""){ // DOMAIN IS EMPTY
          this.updated_value_domain_set = true
          this.updated_value_domain = ""
          this.valueDomain = ""
          this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
          this.updateValueUser(local_val);
          // local_val = "";
        }else if(local_val.split("@").length == 1 && utils.if_null(local_val.split("@")[0]) == ""){ // USER IS EMPTY
          this.updated_value_user_set = true
          this.updated_value_user = ""
          this.valueUser = ""
          this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
          this.updateValueDomain(local_val);
        }else{
          this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
          this.updateValue(local_val);
        }
        this.localRefreshSequecnce++;
        return cb(true);
      }
    }
    if(this.$props.data.page_controller){
      this.$props.data.page_controller_msg = (options) =>{
        switch (options.cmd) {
          case "enable":
            this.pageControllerDisabled = false;
            break;
          case "disable":
            this.pageControllerDisabled = true;
            break;
          default:
            break;
        }
      }
    }
  },

  props: ["data", "value", "option", "read"]
};
</script>
<style >
  .style-chooser-email .vs__selected{
    color:black;
    font-size: 14px;
    margin: 2px 1px;
  }
</style>
<style scoped>
.esma_error_field {
  color:red;
}
.is_required{
  color:red;
}
.form-control[disabled],
fieldset[disabled] .form-control {
  background-color: #cccccc;

  padding: 0px 6px 0px 6px;
}
.form-control {
  color: black;
  height: 24px;

  padding: 0px 6px 0px 6px;
}
.form-control::selection {
  color: white;
  background: #575757;
}
::-webkit-input-placeholder { /* Edge */
  color: red;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: red;
}

::placeholder {
  color: red;
}
</style>



// WEBPACK FOOTER //
// email-box.vue?11d2c8c4